import { gql } from "@apollo/client";

export const GET_FINANCE_TREE_TRANSACTION = gql`
  query GetFinanceTreeTransaction($id: Int!) {
    getFinanceTreeTransaction(id: $id) {
      id
      transactionNumber
      date
      description
      imageId
      totalDebit
      totalCredit
      total
      isBalanced
      createdAt
      updatedAt
      image {
        id
        fileName
        originalName
        mimeType
        size
        type
        url
        isActive
        altText
        description
        width
        height
        duration
        hash
        tags
        expiresAt
        createdAt
        updatedAt
      }
      transactionLines {
        id
        transactionId
        financeTreeId
        description
        debit
        credit
        createdAt
        updatedAt
      }
    }
  }
`;

